import {AfterViewInit, Component, ElementRef, Input, ViewChild, ViewEncapsulation} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'si-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SvgIconComponent implements AfterViewInit {
  @Input() iconPath: string;
  @Input() iconColor = '--color-main1';
  @ViewChild('svgIconContainer', {static: true}) svgIconContainer: ElementRef;

  constructor(
    private http: HttpClient
  ) { }

  async ngAfterViewInit(): Promise<void> {
    await this.loadSvgImage();
    this.setColor();
  }

  async loadSvgImage(): Promise<void> {
    const svg = await this.http.get(this.iconPath, {responseType: 'text'}).toPromise();
    this.svgIconContainer.nativeElement.innerHTML = svg;
  }

  setColor(): void {
    const colorValue = getComputedStyle(document.documentElement).getPropertyValue(this.iconColor).trim();
    this.svgIconContainer.nativeElement.style.setProperty('--icon-color', colorValue);
  }
}
